import { Tabs as TabsPrimitive } from "@base-ui/react/tabs";
import { cn } from "@/lib/utils";

function Tabs({ className, ...props }) {
  return <TabsPrimitive.Root data-slot="tabs" className={cn("flex w-full flex-col gap-4", className)} {...props} />;
}

function TabsList({ className, ...props }) {
  return (
    <TabsPrimitive.List
      data-slot="tabs-list"
      className={cn("flex items-center gap-1 rounded-lg border border-border-primary bg-background-tertiary/30 p-1", className)}
      {...props}
    />
  );
}

function TabsTab({ className, ...props }) {
  return (
    <TabsPrimitive.Tab
      data-slot="tabs-tab"
      className={cn(
        "rounded-md px-3.5 py-2 text-sm font-medium text-text-secondary outline-none transition-colors data-[active]:text-text-primary data-[active]:bg-background-secondary data-[active]:shadow-sm",
        className,
      )}
      {...props}
    />
  );
}

function TabsPanel({ className, ...props }) {
  return <TabsPrimitive.Panel data-slot="tabs-panel" className={cn("flex flex-col gap-4", className)} {...props} />;
}

export { Tabs, TabsList, TabsTab, TabsPanel };
